<template>
  <amplify-authenticator username-alias="email">
    <amplify-sign-up slot="sign-up" username-alias="email" :form-fields.prop="formFields"></amplify-sign-up>
    <amplify-sign-in slot="sign-in" username-alias="email"></amplify-sign-in>
  </amplify-authenticator>
</template>

<script>
import { API, Hub } from "aws-amplify";
import Auth from "@aws-amplify/auth";
import { createLprAuditLog } from "../graphql/mutations";
import AmplifyStore from "../store/store";

export default {
  name: "UBNLPRAuthComponent",
  async mounted() {
    Hub.listen("auth", data => {
      const { payload } = data;
      this.onAuthEvent(payload);
    });
  },
  async created() {
    fetch("https://api.ipify.org?format=json")
      .then(response => response.json())
      .then(response => {
        this.myip = response.ip;
      });
    let user = null;
    try {
      user = await Auth.currentAuthenticatedUser();

      if (user) {
        await this.findUser();
        await this.fetchTenant();
        await this.$router.replace(this.$route.query.redirect || "/Restricted");
      }
    } catch (err) {
      user = null;
    }
  },
  async destroyed() {
    this.tenant = null;
  },
  data() {
    return {
      countID: "",
      currentUser: "",
      tenant: null,
      lprcounts: [],
      myip: null,
      formFields: [
        {
          type: "email",
          label: "Email:",
          placeholder: "",
          required: true
        },
        {
          type: "password",
          label: "Password:",
          placeholder: "",
          required: true
        },
        {
          type: "custom:organization",
          label: "Organization:",
          placeholder: "",
          required: true
        },
        {
          type: "custom:level",
          label: "User Level:",
          placeholder: "",
          required: true
        }
      ]
    };
  },
  methods: {
    async onAuthEvent(payload) {
      switch (payload.event) {
        case "signIn":
          AmplifyStore.commit("setUser", null);
          AmplifyStore.commit("setToken", null);
          await this.findUser();
          await this.fetchTenant();
          if (this.myip) {
            await this.createLPRAuditLog("signed in from " + this.myip);
          } else {
            await this.createLPRAuditLog("signed in");
          }
          this.$router.replace(this.$route.query.redirect || "/Restricted");

          break;
        case "signUp":
          break;
        case "signOut":
          AmplifyStore.commit("setUser", null);
          AmplifyStore.commit("setToken", null);
          break;
        case "signIn_failure":
          AmplifyStore.commit("setUser", null);
          AmplifyStore.commit("setToken", null);
          break;
        case "configured":
      }
    },
    async findUser() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        AmplifyStore.commit("setUser", user);
        this.currentUser = user.signInUserSession.idToken.payload.email;
      } catch (err) {
        this.currentUser = "";
      }
    },
    async fetchTenant() {
      try {
        // get the access token of the signed in user
        const { accessToken } = await Auth.currentSession();
        // get the tenant from the top of the cognito groups list
        const cognitogroups = accessToken.payload["cognito:groups"];
        this.tenant = cognitogroups[0];
        AmplifyStore.commit("setToken", cognitogroups[0]);
      } catch (err) {
        console.log(err);
        this.tenant = null;
      }
    },
    async createLPRAuditLog(log) {
      if (!this.currentUser || !this.tenant || !log) {
        return;
      }
      let user = this.currentUser;
      let tenant = this.tenant;
      const logObject = { log, tenant, user };
      await API.graphql({
        query: createLprAuditLog,
        variables: { input: logObject }
      });
    }
  }
};
</script>
